export default {"src":"/_next/static/media/img_quiz_point.10366038.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};